'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject_es = require('../../lib/style-inject/dist/style-inject.es.js');

var css_248z = ".RadioGroup-module_radioGroup__LRlxm{display:flex;flex-direction:column;flex-wrap:wrap}.RadioGroup-module_row__rSgbG{flex-direction:row}";
var styles = {"radioGroup":"RadioGroup-module_radioGroup__LRlxm","row":"RadioGroup-module_row__rSgbG"};
styleInject_es["default"](css_248z);

exports["default"] = styles;
//# sourceMappingURL=RadioGroup.module.scss.js.map
